import { Navigate, Route, Routes } from 'react-router-dom'
import DefectList from './pages/DefectList/DefectList'
import Factory from './pages/Factory/Factory'
import InspectionAQL from './pages/InspectionAQL/InspectionAQL'
import InspectionType from './pages/InspectionType/InspectionType'
import Property from './pages/Property/Property'
import Supplier from './pages/Supplier/Supplier'
import DefectItem from './pages/DefectItem/DefectItem'

export default function DataManagmentRoutes() {
  return (
    <Routes>
      <Route path="" element={<Navigate to={'supplier'} />} />
      <Route path="supplier" element={<Supplier />} />
      <Route path="factory" element={<Factory />} />
      <Route path="inspection-type" element={<InspectionType />} />
      <Route path="inspection-aql" element={<InspectionAQL />} />
      <Route path="defect-list" element={<DefectList />} />
      <Route path="defect-list/:id" element={<DefectItem />} />
      <Route path="property" element={<Property />} />
    </Routes>
  )
}
